import React, { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import usePermission from "./hooks/usePermission";

const PermissionRoute = ({ permission, children }) => {
  const { token, user, isRefreshing, refreshUser } = useAuth();
  const { can } = usePermission();
  const refreshedRef = useRef(false);
  const [localRefreshing, setLocalRefreshing] = useState(false);

  const hasAccess = can(permission);

  useEffect(() => {
    if (!isRefreshing && !hasAccess && token && !refreshedRef.current && !localRefreshing) {
      refreshedRef.current = true;
      setLocalRefreshing(true);
      refreshUser().finally(() => setLocalRefreshing(false));
    }
  }, [isRefreshing, hasAccess, token, localRefreshing, refreshUser]);

  if (!token) return <Navigate to="/login" replace />;

  if (isRefreshing || localRefreshing || (token && !user)) return null;

  return hasAccess ? children : <Navigate to="/unauthorized" replace />;
};

export default PermissionRoute;
